export default {"src":"/_next/static/media/Download-DeepLink.a91ae4d9.svg","height":52,"width":170,"blurWidth":0,"blurHeight":0};